import content from "./content"
import homeVideoReviews from "./homeVideoReviews"
import news from "./news"
import site from "./site"
import socials from "./socials"
import tmdb from "./tmdb"

export default {
  content,
  homeVideoReviews,
  news,
  site,
  socials,
  tmdb
}
